import pagination from '@/components/pagination'
export default {
    name: 'sla',
    components: {
        pagination
    },
    data () {
      return {
        currentPage: 1,
      }
    },
    methods: {
        setPage (page) {
            this.currentPage = page
        }
    },
    created () {

    }
  }
  


// WEBPACK FOOTER //
// ./src/views/fdm/script.js